<template>
  <div class="event-event">
    <img src="/playground_assets/danseuse.png" class="event-icon" alt="Nuance logo">
    <a :href="topNotification.url" class="event-text" target="_blank">
      <span>
        {{ topNotification.first_part }}
      </span>
      <span class="event-text2">{{ topNotification.bold_part }}</span>
      <span>{{ topNotification.last_part }}</span>
    </a>
  </div>
</template>

<script>
export default {
  name: 'Event',
  data() {
    return {
      topNotification: {
        first_part: '',
        bold_part: 'Support the radio',
        last_part: '',
        url: 'https://linktr.ee/nuance.radio'
      }
    }
  }
}
</script>

<style scoped>
.event-event {
  flex: 0 0 auto;
  display: flex;
  position: relative;
  align-items: center;
  flex-direction: row;
  top: HalfUnit;
  left: 0px;
  bottom: HalfUnit;
  position: absolute;
}

.event-icon {
  width: 1.5rem;
  height: 1.5rem;
  margin-left: 0.4rem;
  margin-right: 0.4rem;
}
.event-text {
  color: #000000;
  font-size: var(--event);
  font-style: normal;
  font-family: Syne;
  font-weight: 400;
  text-decoration: underline   none;
}
.event-text2 {
  font-weight: 700;
  text-decoration: underline;
}

@media(max-width: 1200px) {
  .event-icon {

    margin-left: 0.4rem;
    margin-right: 0.4rem;
  }
  .event-text {
    font-size: 0.9vw;
  }
}
@media(max-width: 991px) {
  .event-icon {

    margin-left: 0.8vw;
  }
  .event-text {
    font-size: 1.2vw;
  }
}
@media(max-width: 767px) {
  .event-event {
    display: none;
  }
}
</style>
